<div class="login">
  <h1>Login</h1>

  <div class="label info red token-errors login" *ngIf="dataErrors.length > 0">
    <div *ngFor="let error of dataErrors">
      {{error[0]}}: {{error[1]}}
    </div>
    
    <span class="close-icon black" (click)="dataErrors = []"></span>
  </div>
  <p-toast [life]="5000" [baseZIndex]="10000" class="p-toast-message-conten" contentStyle="padding: 16px;"></p-toast>
  <form id="LoginForm" #loginForm="ngForm" (submit)="onLoginClick()" ngNativeValidate>
    <ng-template #tipContent id="lblLoginError">{{loginErrorMessage}}</ng-template>
    <div class="form-group">
      <label>email</label>
      <input aria-label="email"  type="email" [(ngModel)]="userLogin.username" name="login" id="iptEmail" class="auth-input"
        (focus)="tooltip.close()" required autofocus>
    </div>
    <div class="form-group">
      <label>password</label>
      <input aria-label="password"  [type]="showPassword ? 'text' : 'password'" id="password" [(ngModel)]="userLogin.password" name="password"
        (focus)="tooltip.close()" class="auth-input" triggers="manual" placement="bottom" [ngbTooltip]="tipContent" #tooltip="ngbTooltip" required>
      
      <div class="password-eye" (click)="showPassword = !showPassword">
        <svg xmlns="http://www.w3.org/2000/svg" width="24.43" height="19" viewBox="0 0 25.929 20.5">
          <g id="Group_179" data-name="Group 179" transform="translate(-2.25 -4.25)">
            <path id="Path_280" data-name="Path 280"
              d="M15.952,10.194a4.074,4.074,0,1,1-5.761,0,4.077,4.077,0,0,1,5.761,0" transform="translate(2.142 1.429)"
              fill="none" stroke="#bababa" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
            <path id="Path_281" data-name="Path 281"
              d="M3,14.5a5.9,5.9,0,0,1,.605-2.595h0A12.829,12.829,0,0,1,15.214,5a12.829,12.829,0,0,1,11.609,6.905h0a5.865,5.865,0,0,1,0,5.19h0A12.829,12.829,0,0,1,15.214,24,12.829,12.829,0,0,1,3.605,17.095h0A5.9,5.9,0,0,1,3,14.5Z"
              transform="translate(0)" fill="none" stroke="#bababa" stroke-linecap="round" stroke-linejoin="round"
              stroke-width="1.5" fill-rule="evenodd" />
          </g>
        </svg>

      </div>
    </div>
    <div class="form-group text-right">
      <input aria-label=""  id="btnLogin" name="loginbutton" type="submit" class="auth-submit" [ngClass]="{'loading': loadingStatus}"
        [value]="loadingStatus ? 'LOADING...' : 'sign in'">
      <a class="forgot-link" [routerLink]="['/password-request']" routerLinkActive="active" id="lnkForgotPassword">
        forgot password?
      </a>
    </div>
  </form>
</div>

